import { api } from '../../api/client';
import { Card, LoadError, Loading, PageHeader } from '../../components/ui';
import { renderMarkdown } from '../../help';
import { useData } from '../../lib/useData';

/** Everything that changed in each version, for the Stitch team (customers get What's new). */
export function AdminChangelog() {
  const data = useData(() => api.changelog(), []);
  return (
    <>
      <PageHeader eyebrow={data.data ? `Running ${data.data.version}` : 'Stitch Admin'} title="Changelog" />
      <div className="content">
        <Card>
          {data.error ? (
            <LoadError error={data.error} retry={data.reload} />
          ) : !data.data ? (
            <Loading label="Loading the changelog" />
          ) : (
            // Our own file, rendered with the help center's safe Markdown rules (no raw HTML).
            <div className="card-body help-article changelog" dangerouslySetInnerHTML={{ __html: renderMarkdown(data.data.markdown) }} />
          )}
        </Card>
      </div>
    </>
  );
}
